
import { Card, CardContent } from "@/components/ui/card";
import { DataOneUtils } from "./utils";
import { Badge } from "@/components/ui/badge";

interface AdasFeaturesProps {
  data?: any;
  selectedStyle?: any;
  selectedStyleIndex?: number;
}

export const AdasFeatures = ({ data, selectedStyle, selectedStyleIndex }: AdasFeaturesProps) => {
  // Extract ADAS features based on selection or from data if not directly provided
  let adasSystems = [];
  
  if (selectedStyle) {
    // Try to get ADAS features directly from the selected style
    const systems = selectedStyle.adas_features?.adas_system || 
                   selectedStyle.style_data_packs?.advanced_driver_assistance_systems || [];
    adasSystems = Array.isArray(systems) ? systems : [systems].filter(Boolean);
  } else {
    // Fall back to utility function for getting ADAS from overall data
    adasSystems = DataOneUtils.extractAdasFeatures(data) || [];
  }
  
  if (!adasSystems || adasSystems.length === 0) {
    return (
      <div className="text-gray-500">No ADAS features available</div>
    );
  }

  return (
    <div className="space-y-4">
      {adasSystems.map((system, index) => {
        // Handle different data structure formats
        const systemName = system.adas_system_name || system.name || 'Unknown System';
        const systemDescription = system.adas_system_description || system.description || '';
        const availability = system.availability?.toLowerCase() || '';
        
        let badgeVariant = "secondary";
        if (availability.includes("standard")) {
          badgeVariant = "default";
        } else if (availability.includes("optional")) {
          badgeVariant = "outline";
        }
        
        return (
          <Card key={index}>
            <CardContent className="p-4">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <h3 className="text-base font-medium">{systemName}</h3>
                {system.availability && (
                  <Badge variant={badgeVariant as any} className="capitalize">
                    {system.availability}
                  </Badge>
                )}
              </div>
              
              {systemDescription && (
                <p className="mt-2 text-sm text-gray-600">{systemDescription}</p>
              )}
              
              {/* Display sensors if available */}
              {system.adas_sensors && system.adas_sensors.length > 0 && (
                <div className="mt-3">
                  <h4 className="text-sm font-medium text-gray-500">Sensors</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-1">
                    {system.adas_sensors.map((sensor, sensorIndex) => (
                      <div key={sensorIndex} className="text-xs text-gray-600 border rounded-md p-2">
                        <span className="font-medium">{sensor.sensor_type}</span>
                        {sensor.sensor_location && (
                          <span className="block mt-1">Location: {sensor.sensor_location}</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default AdasFeatures;
